import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export enum FlowType {
  GIFT_CARD = 'GIFT_CARD',
  PAYMENT = 'PAYMENT',
}

interface FlowState {
  stack: string[];
}

interface NavigationState {
  flows: Record<FlowType, FlowState>;
}

const initialState: NavigationState = {
  flows: {
    GIFT_CARD: { stack: [] },
    PAYMENT: { stack: [] },
  },
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    initFlow(state, action: PayloadAction<{ flow: FlowType; initial: string }>) {
      state.flows[action.payload.flow].stack = [action.payload.initial];
    },

    pushView(state, action: PayloadAction<{ flow: FlowType; view: string }>) {
      // Prevent pushing the same view consecutively
      if (state.flows[action.payload.flow].stack.slice(-1)[0] === action.payload.view) {
        return;
      }
      state.flows[action.payload.flow].stack.push(action.payload.view);
    },

    replaceView(state, action: PayloadAction<{ flow: FlowType; view: string }>) {
      state.flows[action.payload.flow].stack.pop();
      state.flows[action.payload.flow].stack.push(action.payload.view);
    },

    popView(state, action: PayloadAction<{ flow: FlowType }>) {
      const stack = state.flows[action.payload.flow].stack;
      if (stack.length > 1) stack.pop();
    },

    resetFlow(state, action: PayloadAction<{ flow: FlowType }>) {
      state.flows[action.payload.flow].stack = [];
    },
  },
});

export const selectCurrentView = (flow: FlowType) =>
  createSelector(
    (state: RootState) => state.navigation.flows[flow].stack,
    (stack) => stack[stack.length - 1]
  );

export const { initFlow, pushView, replaceView, popView, resetFlow } = navigationSlice.actions;

export default navigationSlice.reducer;
